module.exports = __webpack_public_path__ + "static/media/cancelIcon.e7d0ed75.svg";